<script lang="ts">
  import type { Snippet } from 'svelte';
  let { children }: { children: Snippet } = $props();
</script>

<div class="public-layout">
  <header class="public-header">
    <div class="container header-inner">
      <a href="#/" class="logo">Beat Duel</a>
      <a href="#/login" class="btn btn-primary btn-pill">Sign In</a>
    </div>
  </header>
  <main class="container main-content">
    {@render children()}
  </main>
</div>

<style>
  .public-layout {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .public-header {
    border-bottom: 1px solid var(--border);
    padding: 0.75rem 0;
  }
  .header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    white-space: nowrap;
    font-size: 1.6rem;
    font-weight: 800;
    background: linear-gradient(135deg, var(--pink) 0%, var(--purple) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .main-content {
    flex: 1;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
</style>
